import React from "react";
import { useHistory } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import ExploringSpaceBrand from "../StudyDashboard/components/ExploringSpaceBrand";
import BackToLearningButton from "../StudyDashboard/components/BackToLearningButton";
import DashboardNotificationDropdown from "../StudyDashboard/components/DashboardNotificationDropdown";
import DashboardProfileAvatar from "../StudyDashboard/components/DashboardProfileAvatar";
import { navigateToDashboardHome } from "./dashboardNavigation";
import "./ExploreMotionTopBar.css";
import "./DashboardLayout.css";

const ExploreMotionTopBar = ({ fixed = false }) => {
  const history = useHistory();
  const dispatch = useDispatch();
  const userData = useSelector((state) => state.auth.user);

  return (
    <header
      className={`dashboard-top-bar dashboard-top-bar--courses${
        fixed ? " explore-motion-top-bar" : ""
      }`}
    >
      <ExploringSpaceBrand />
      <div className="dashboard-top-bar__courses-actions">
        <BackToLearningButton
          onClick={() => navigateToDashboardHome(history, dispatch)}
        />
        <div className="dashboard-top-bar__utilities">
          <DashboardNotificationDropdown />
          <DashboardProfileAvatar
            image={userData?.image}
            name={userData?.name}
            onClick={() => history.push("/profile")}
          />
        </div>
      </div>
    </header>
  );
};

export default ExploreMotionTopBar;
